import { c as _c } from "react/compiler-runtime";
import { AdvisorsLayout } from '@src/components/sco/Advisors/layout/AdvisorsLayout';
import { RequestsLayout } from '@src/components/sco/Requests/Layout/RequestsLayout';
import { useParams } from 'next/navigation';
import { ReactNode } from 'react';
type AdvisorsEmbeddedShellProps = {
  children: ReactNode;
  showAside?: boolean;
  focusMode?: boolean;
};

/**
 * Embed Advisors inside Request Workspace (manager view), similar to
 * investor-matching / member-matching embeds under `/requests/manage/:id/...`.
 *
 * Links stay under `/requests/manage/:id/advisors` via `useAdvisorsPaths()`.
 */
export const AdvisorsEmbeddedShell = t0 => {
  const $ = _c(9);
  const {
    children,
    showAside,
    focusMode
  } = t0;
  const params = useParams();
  let t1;
  if ($[0] !== params.groupRequestId) {
    t1 = params.groupRequestId?.toString();
    $[0] = params.groupRequestId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const groupRequestId = t1;
  let t2;
  if ($[2] !== children || $[3] !== focusMode || $[4] !== showAside) {
    t2 = <AdvisorsLayout embedded={true} focusMode={focusMode} showAside={showAside}>{children}</AdvisorsLayout>;
    $[2] = children;
    $[3] = focusMode;
    $[4] = showAside;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== groupRequestId || $[7] !== t2) {
    t3 = <RequestsLayout groupRequestId={groupRequestId} isManagerView={true} requireAuth={true} mainPanel={t2} />;
    $[6] = groupRequestId;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};